<template>
  <div class="login-container">
    <img src="@/assets/logo.png" alt="Logo" class="post-logo">
    <h2>Login with Token</h2>
    <div class="form-group create-account-link">
      <router-link to="/login">or use username/password</router-link>
    </div>
    <form @submit.prevent="loginWithToken" class="login-form">
      <div class="form-group">
        <label for="token">JWT Token</label>
        <textarea
          v-model="token"
          id="token"
          class="token-field"
          placeholder="Paste your JWT token here..."
          rows="4"
          required
        />
      </div>
      <button type="submit" class="submit-button">Login with Token</button>
      <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
    </form>
  </div>
  <FooterPublic v-if="isWeb" />
</template>

<script>
import eventBus from '@/utils/eventBus';
import FooterPublic from "@/components/FooterPublic.vue";
import { Capacitor } from '@capacitor/core';
import pushNotificationService from '@/services/pushNotificationService';

export default {
  name: 'LoginToken',
  components: {
    FooterPublic
  },
  data() {
    return {
      token: '',
      errorMessage: '',
      isWeb: false
    };
  },
  async created() {
    const platform = Capacitor.getPlatform();
    this.isWeb = platform === 'web';
    
    // Initialize push notifications on mobile platforms
    if (!this.isWeb) {
      await pushNotificationService.initialize();
    }
  },
  methods: {
    async loginWithToken() {
      try {
        // Validate token format (basic check)
        if (!this.token.trim()) {
          this.errorMessage = 'Please enter a valid JWT token';
          return;
        }

        // Store the token in local storage
        localStorage.setItem('access_token', this.token.trim());

        // Send device token to backend (mobile only)
        if (!this.isWeb) {
          const result = await pushNotificationService.registerDeviceToken(this.token.trim());
          if (result.success) {
            console.log('✅ Device info sent to backend');
          } else if (result.queued) {
            console.log('📋 Device info queued - will send when token is ready');
          }
        }

        // Emit an event to notify the navbar about the login
        eventBus.emit('userLoggedIn');

        // Redirect to the home timeline or dashboard
        this.$router.push('/timeline');
      } catch (error) {
        this.errorMessage = 'Invalid token or authentication failed';
        console.error('Token login error:', error);
      }
    }
  }
};
</script>

<style scoped>
.login-container {
  max-width: 400px;
  margin: 20px auto 150px auto;
  padding: 20px;
  background-color: #192734;
  border-radius: 16px;
  color: #d9d9d9;
}

h2 {
  text-align: center;
  color: #1da1f2;
  margin-bottom: 20px;
  margin-top: 15px;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

label {
  color: #8899a6;
  margin-bottom: 5px;
}

.token-field {
  padding: 12px;
  background-color: #15202b;
  border: 1px solid #38444d;
  border-radius: 10px;
  color: #d9d9d9;
  font-size: 14px;
  font-family: 'Courier New', monospace;
  resize: vertical;
  min-height: 80px;
}

.token-field::placeholder {
  color: #8899a6;
}

.submit-button {
  padding: 12px 20px;
  background-color: #1da1f2;
  border: none;
  border-radius: 10px;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s;
}

.submit-button:hover {
  background-color: #0c8ddb;
}

.create-account-link {
  text-align: center;
  font-size: 12px;
  margin-top: -20px; 
  margin-bottom: 20px;
}

.create-account-link a {
  color: #1da1f2;
  text-decoration: underline;
}

.create-account-link a:hover {
  text-decoration: underline;
  color: #0c8ddb;
}

.error-message {
  color: #e0245e;
  text-align: center;
  margin-top: 10px;
}

.post-logo {
  display: block;
  margin: 0 auto 5px;
  width: 80px;
}
</style> 